import { createAPI } from '@common'
export default {
  postRRClues: config => createAPI('customEncryptApiName-1/0w20ss0dmvft', 'POST', config),
  getRRCluesDetail: config => createAPI('customEncryptApiName-1/0w20ss0dmvft0efubjm', 'GET', config),
  postRRCluesRemove: config => createAPI('customEncryptApiName-1/0w20ss0dmvft0sfnpwf', 'POST', config),
  postRRcluesCopy: (config, vconfig) => createAPI('customEncryptApiName-1/OFXTQMBO;0w20ssdmvft0dpqz', 'POST', config, {hubForward: true, hub: 'e5/hub', ...vconfig}), // 选用
  postRRCluesUse: config => createAPI('customEncryptApiName-1/0w20ss0dmvft0vtf', 'POST', config) // 记录选用
}
